// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-StyledMenu_cls1__60n5N","cls2":"VeloActionBar-StyledMenu_cls2__g3X1+ VeloActionBar-StyledMenu_cls1__60n5N"};